import { useEffect } from 'react';
import { clearBrowserCache } from '../../config/version';

const CacheManager = ({ children }) => {
    useEffect(() => {
        // Limpiar cache automáticamente al cargar la aplicación
        // Esto asegura que siempre se use la versión más reciente
        const clearCacheOnLoad = () => {
            // Solo limpiar cache si hay problemas de versión
            const currentVersion = localStorage.getItem('app_version');
            const expectedVersion = process.env.REACT_APP_VERSION || '1.0.0';
            
            if (currentVersion !== expectedVersion) {
                console.log('Clearing cache due to version mismatch');
                clearBrowserCache();
                localStorage.setItem('app_version', expectedVersion);
            }
        };

        clearCacheOnLoad();
    }, []);

    return children;
};

export default CacheManager;
